export const SUBMISSION_TYPE = {
    Online: 0,
    Proxy: 1
}

export const STEP_TYPES = {
    Review: "review"
}
